const words = ["民家", "The past refuses to die", "地獄", "The road to redemption leads through Hell", "侍", "A centuries-old curse", "岩手"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w, i) => (
      <span key={i} className={`px-8 ${i % 2 === 0 ? "font-display text-[#C81D25]" : "font-serif-i text-outline"} text-5xl md:text-7xl whitespace-nowrap`}>
        {w}
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-white/10 bg-[#07080B]/70 py-8 backdrop-blur-sm" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
